module.exports = __webpack_public_path__ + "94f486b5f3fea56652b1b76d5e8fc19a.pdf";